export default "__VITE_ASSET__CDaoJ35X__"